import { ForexBuyField } from "@/feature/Forex/api/form/forex-form.interface";

export const forexFormRequestFields: ForexBuyField[] = [
	ForexBuyField.account,
	ForexBuyField.amountUzs,
	ForexBuyField.contractAmount,
	ForexBuyField.contractDate,
	ForexBuyField.contractEndDate,
	ForexBuyField.contractId,
	ForexBuyField.contractNumber,
	ForexBuyField.currency,
	ForexBuyField.currencyAccount,
	ForexBuyField.foreignExchangeId,
	ForexBuyField.fundsSource,
	ForexBuyField.loanAccount,
	ForexBuyField.operDay,
	ForexBuyField.operationType,
	ForexBuyField.otherPurposeDetails,
	ForexBuyField.otherServiceDetails,
	ForexBuyField.partnerCountry,
	ForexBuyField.partnerName,
	ForexBuyField.phoneNumber,
	ForexBuyField.purpose,
	ForexBuyField.receiverAccount,
	ForexBuyField.requestAmount,
	ForexBuyField.reservingAccount,
	ForexBuyField.serviceDescription,
	ForexBuyField.mfo,
	ForexBuyField.course,
	ForexBuyField.templateName,
	ForexBuyField.partnerCountryCode,
];